export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const BACK_PAGE = 'backPage';
export const SET_LIST_LOCATION = 'setListLocation'
